import { render } from "./industry-list-modal.vue?vue&type=template&id=f553a462"
import script from "./industry-list-modal.vue?vue&type=script&lang=js"
export * from "./industry-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__